import FieldNames from '../defaults/FieldNames.json';
import { setDataset, setFilterProjectValue, setProjectDiscoveryDates, setProjectFireCodes, setProjectIDs } from '../redux/slices/filterSlice';
import { setViewingActions, setViewingProjects } from '../redux/slices/menuSlice';
import UserHelperService from '../services/UserHelperService';
import { formatDateForDisplay, getSaveableDate } from './DateHelper';
import { getFilterState, getMenuState, updateStore } from './ReduxHelper';

export function getUpdatedUserInfo(userIDUpdate, guid, userInfo, setModifiedBy, setModifiedOn, setCreatedBy, setCreatedOn, createdBy,
    firstNameUpdate, lastNameUpdate, emailUpdate, nifcUsernameUpdate, userIsActiveUpdate, userIsAdminUpdate, userIsFuelsUpdate, 
    userIsPostFireUpdate, userDefaultAppUpdate, userObjectIDUpdate, isTribalUserUpdate, createdOn, idVal){
    let newUserID;
    if(userIDUpdate){
      newUserID = userIDUpdate;
    } else {
      newUserID = guid;
    }

    var currDate = getSaveableDate(new Date());
    setModifiedBy(userInfo[FieldNames.userFields.nifcUsername])
    setModifiedOn(formatDateForDisplay(currDate));
    if(!createdBy)
    {
      setCreatedBy(userInfo[FieldNames.userFields.nifcUsername])
      setCreatedOn(formatDateForDisplay(currDate));
    }

    const updatedUserInfo = {
      [FieldNames.userFields.id]: idVal,
      [FieldNames.userFields.firstName]: firstNameUpdate,
      [FieldNames.userFields.lastName]: lastNameUpdate,
      [FieldNames.userFields.email]: emailUpdate,
      [FieldNames.userFields.nifcUsername]: nifcUsernameUpdate,
      [FieldNames.userFields.isActive]: userIsActiveUpdate,
      [FieldNames.userFields.isAdmin]: userIsAdminUpdate,
      [FieldNames.userFields.isFuels]: userIsFuelsUpdate,
      [FieldNames.userFields.isPostFire]: userIsPostFireUpdate,
      [FieldNames.userFields.defaultApp]: userDefaultAppUpdate,
      [FieldNames.userFields.objectID]: userObjectIDUpdate,
      [FieldNames.userFields.userID]: newUserID,
      [FieldNames.userFields.isTribalUser]: isTribalUserUpdate,
      [FieldNames.userFields.createdBy]: createdBy ? createdBy: userInfo[FieldNames.userFields.nifcUsername],
      [FieldNames.userFields.createdOnDate]: createdBy ? createdOn: currDate,
      [FieldNames.userFields.lastModifiedBy]: userInfo[FieldNames.userFields.nifcUsername],
      [FieldNames.userFields.lastModifiedDate]: currDate,
    }
    return updatedUserInfo;
}

export async function getUserRoles(rootServiceUrl, config, idVal, newUserID, departmentSelection, agencySelection, regionSelection, 
  unitSelection, role, selectedRole, subUnitSelection, tribeSelection){
    let allUserRoles = [];
    const departmentItems = (departmentSelection && departmentSelection.Department) ? departmentSelection.Department : "";
    const agencyItems = (agencySelection && agencySelection.length > 0) ? agencySelection : [];
    const regionItems = (regionSelection && regionSelection.length > 0) ? regionSelection : [];
    const unitItems = (unitSelection && unitSelection.length > 0) ? unitSelection : [];
    const roleCode = (role && selectedRole) ? role.code : "";
    const subUnitItems = subUnitSelection;
    const tribeItem = (tribeSelection && tribeSelection[FieldNames.units.tribeFullName]) ? tribeSelection[FieldNames.units.tribeFullName] : "";

    // Fail-safe: do not generate malformed blank roles when department/agency is missing.
    if(!departmentItems || !agencyItems || agencyItems.length === 0){

          //No Department or No Agency - Very simple case
          const userRole = {
            [FieldNames.userRoles.appRole]: roleCode,
            UserID: newUserID,
            [FieldNames.userRoles.usersJoinID]: idVal,
            Department: departmentItems,
            Agency: "",
            Region: "",
            Unit: "",
            SubUnit: "",
            UnitType: "",
            Tribe: ""
          }
         return [userRole];
    }

    // Group regions and units by agency to handle each agency independently
    const regionsByAgency = {};
    const unitsByAgency = {};

    // Group regions by their agency
    regionItems.forEach(region => {
      const agency = region[FieldNames.units.agency];
      if(agency) {
        if(!regionsByAgency[agency]) {
          regionsByAgency[agency] = [];
        }
        regionsByAgency[agency].push(region[FieldNames.units.region]);
      }
    });

    // Group units by their agency
    unitItems.forEach(unit => {
      const agency = unit[FieldNames.units.agency];
      if(agency) {
        if(!unitsByAgency[agency]) {
          unitsByAgency[agency] = [];
        }
        unitsByAgency[agency].push(unit[FieldNames.units.unit]);
      }
    });

    // Check if we have NO regions at all - simple agency-only case
    const hasAnyRegions = regionItems && regionItems.length > 0;

    if(!hasAnyRegions){
        // Department+Agency role without explicit region scope.
        // Create a separate user role for each agency
        agencyItems.forEach(agency => {
          const userRole = {
            [FieldNames.userRoles.appRole]: roleCode,
            UserID: newUserID,
            [FieldNames.userRoles.usersJoinID]: idVal,
            Department: departmentItems,
            Agency: agency.Agency,
            Region: "",
            Unit: "",
            SubUnit: "",
            UnitType: "",
            Tribe: ""
          }
          allUserRoles.push(userRole);
        });
        return allUserRoles;
    } else {
        // We have at least some regions - need to handle each agency independently
        // Some agencies might have regions/units, others might not

        // Process each agency
        const processAgency = async (agencyObj) => {
          const agencyName = agencyObj.Agency;
          const agencyRegions = regionsByAgency[agencyName] || [];
          const agencyUnits = unitsByAgency[agencyName] || [];

          // If this agency has no regions, create an agency-only role
          if(agencyRegions.length === 0) {
            const userRole = {
              [FieldNames.userRoles.appRole]: roleCode,
              UserID: newUserID,
              [FieldNames.userRoles.usersJoinID]: idVal,
              Department: departmentItems,
              Agency: agencyName,
              Region: "",
              Unit: "",
              SubUnit: "",
              UnitType: "",
              Tribe: ""
            };
            allUserRoles.push(userRole);
            return;
          }

          // This agency has regions - process BLM subunits if applicable
          if(agencyName === FieldNames.agencies.blm && agencyUnits && agencyUnits.length > 0){
            const subUnitsWithUnits = await UserHelperService.getSubUnitsForUnitsByUnits(agencyUnits);

              subUnitItems.forEach(subUnitItem => {
                const itemToSave = subUnitsWithUnits.filter(x =>
                  x[FieldNames.units.subUnit] === subUnitItem[FieldNames.units.subUnit] &&
                  x[FieldNames.units.agency] === agencyName
                );
                if(itemToSave && itemToSave.length > 0){
                  const userRole = {
                    [FieldNames.userRoles.appRole]: roleCode,
                    UserID: newUserID,
                    [FieldNames.userRoles.usersJoinID]: idVal,
                    Department: itemToSave[0][FieldNames.units.department],
                    Agency: itemToSave[0][FieldNames.units.agency],
                    Region: itemToSave[0][FieldNames.units.region],
                    Unit: itemToSave[0][FieldNames.units.unit],
                    SubUnit: itemToSave[0][FieldNames.units.subUnit],
                    UnitType: itemToSave[0][FieldNames.units.unitType],
                    Tribe: ""
                  };
                  allUserRoles.push(userRole);
                }
              });

              // Check for units without subunits for this agency
              let userRoleUnits = [];
              if(allUserRoles && allUserRoles.length > 0){
                userRoleUnits = allUserRoles.filter(r => r.Agency === agencyName).map(x => x[FieldNames.userRoles.unit]);
              }
              agencyUnits.forEach(unitItem => {
                if(userRoleUnits && !userRoleUnits.includes(unitItem)){
                  let unitItemToSave = subUnitsWithUnits.filter(x => x[FieldNames.units.unit] === unitItem && x[FieldNames.units.subUnit] === "");
                  let unitTypeValue = "";
                  if(unitItemToSave && unitItemToSave.length > 0){
                    unitTypeValue = unitItemToSave[0][FieldNames.units.unitType];
                  } else {
                    unitItemToSave = subUnitsWithUnits.filter(x => x[FieldNames.units.unit] === unitItem);
                  }
                  if(unitItemToSave && unitItemToSave.length > 0){
                    const userRole = {
                      [FieldNames.userRoles.appRole]: roleCode,
                      UserID: newUserID,
                      [FieldNames.userRoles.usersJoinID]: idVal,
                      Department: unitItemToSave[0][FieldNames.units.department],
                      Agency: unitItemToSave[0][FieldNames.units.agency],
                      Region: unitItemToSave[0][FieldNames.units.region],
                      Unit: unitItem,
                      SubUnit: "",
                      UnitType: unitTypeValue,
                      Tribe: ""
                    };
                    allUserRoles.push(userRole);
                  }
                }
              });

              // Check for regions without units for this agency
              if(agencyRegions && agencyRegions.length > 0){
                let userRoleRegions = [];
                if(allUserRoles && allUserRoles.length > 0){
                  userRoleRegions = allUserRoles.filter(r => r.Agency === agencyName).map(x => x[FieldNames.userRoles.region]);
                }
                agencyRegions.forEach(regionItem => {
                  if(userRoleRegions && !userRoleRegions.includes(regionItem)){
                    const regionItemToSave = subUnitsWithUnits.filter(x => x[FieldNames.units.region] === regionItem);
                    if(!regionItemToSave || regionItemToSave.length === 0){
                      const userRole = {
                        [FieldNames.userRoles.appRole]: roleCode,
                        UserID: newUserID,
                        [FieldNames.userRoles.usersJoinID]: idVal,
                        Department: subUnitsWithUnits[0][FieldNames.units.department],
                        Agency: subUnitsWithUnits[0][FieldNames.units.agency],
                        Region: regionItem,
                        Unit: "",
                        SubUnit: "",
                        UnitType: "",
                        Tribe: ""
                      };
                      allUserRoles.push(userRole);
                    }
                  }
                });
              }
          } else if(agencyName === FieldNames.agencies.bia && agencyUnits && agencyUnits.length > 0) {
            // Process BIA tribal units
            const tribesWithUnits = await UserHelperService.getTribesForUnitsByUnits(agencyUnits);

              const itemToSave = tribesWithUnits.filter(x =>
                x[FieldNames.units.tribeFullName] === tribeItem &&
                x[FieldNames.units.agency] === agencyName
              );
              if(itemToSave && itemToSave.length > 0){
                const userRole = {
                  [FieldNames.userRoles.appRole]: roleCode,
                  UserID: newUserID,
                  [FieldNames.userRoles.usersJoinID]: idVal,
                  Department: itemToSave[0][FieldNames.units.department],
                  Agency: itemToSave[0][FieldNames.units.agency],
                  Region: itemToSave[0][FieldNames.units.region],
                  Unit: itemToSave[0][FieldNames.units.unit],
                  SubUnit: "",
                  UnitType: itemToSave[0][FieldNames.units.unitType],
                  Tribe: itemToSave[0][FieldNames.units.tribeFullName]
                };
                allUserRoles.push(userRole);
              }

              // Check for units without tribes for this agency
              let userRoleUnits = [];
              if(allUserRoles && allUserRoles.length > 0){
                userRoleUnits = allUserRoles.filter(r => r.Agency === agencyName).map(x => x[FieldNames.userRoles.unit]);
              }
              agencyUnits.forEach(unitItem => {
                if(userRoleUnits && !userRoleUnits.includes(unitItem)){
                  let unitItemToSave = tribesWithUnits.filter(x => x[FieldNames.units.unit] === unitItem && x[FieldNames.units.tribeFullName] === "");
                  let unitTypeValue = "";
                  if(unitItemToSave && unitItemToSave.length > 0){
                    unitTypeValue = unitItemToSave[0][FieldNames.units.unitType];
                  } else {
                    unitItemToSave = tribesWithUnits.filter(x => x[FieldNames.units.unit] === unitItem);
                  }
                  if(unitItemToSave && unitItemToSave.length > 0){
                    const userRole = {
                      [FieldNames.userRoles.appRole]: roleCode,
                      UserID: newUserID,
                      [FieldNames.userRoles.usersJoinID]: idVal,
                      Department: unitItemToSave[0][FieldNames.units.department],
                      Agency: unitItemToSave[0][FieldNames.units.agency],
                      Region: unitItemToSave[0][FieldNames.units.region],
                      Unit: unitItem,
                      SubUnit: "",
                      UnitType: unitTypeValue,
                      Tribe: ""
                    };
                    allUserRoles.push(userRole);
                  }
                }
              });

              // Check for regions without units for this agency
              if(agencyRegions && agencyRegions.length > 0){
                let userRoleRegions = [];
                if(allUserRoles && allUserRoles.length > 0){
                  userRoleRegions = allUserRoles.filter(r => r.Agency === agencyName).map(x => x[FieldNames.userRoles.region]);
                }
                agencyRegions.forEach(regionItem => {
                  if(userRoleRegions && !userRoleRegions.includes(regionItem)){
                    const regionItemToSave = tribesWithUnits.filter(x => x[FieldNames.units.region] === regionItem);
                    if(!regionItemToSave || regionItemToSave.length === 0){
                      const userRole = {
                        [FieldNames.userRoles.appRole]: roleCode,
                        UserID: newUserID,
                        [FieldNames.userRoles.usersJoinID]: idVal,
                        Department: tribesWithUnits[0][FieldNames.units.department],
                        Agency: tribesWithUnits[0][FieldNames.units.agency],
                        Region: regionItem,
                        Unit: "",
                        SubUnit: "",
                        UnitType: "",
                        Tribe: ""
                      };
                      allUserRoles.push(userRole);
                    }
                  }
                });
              }
          } else {
            // General case: agency has regions but no units, or non-BLM/BIA agency with regions/units
            if(agencyRegions && agencyRegions.length > 0){
              const unitsWithRegions = await UserHelperService.getRolesByAgenciesRegions([agencyName], agencyRegions);

                agencyUnits.forEach(unitItem => {
                  const itemToSave = unitsWithRegions.filter(x => x[FieldNames.units.unit] === unitItem);
                  if(itemToSave && itemToSave.length > 0){
                    const userRole = {
                      [FieldNames.userRoles.appRole]: roleCode,
                      UserID: newUserID,
                      [FieldNames.userRoles.usersJoinID]: idVal,
                      Department: itemToSave[0][FieldNames.units.department],
                      Agency: itemToSave[0][FieldNames.units.agency],
                      Region: itemToSave[0][FieldNames.units.region],
                      Unit: itemToSave[0][FieldNames.units.unit],
                      SubUnit: "",
                      UnitType: itemToSave[0][FieldNames.units.unitType],
                      Tribe: ""
                    };
                    allUserRoles.push(userRole);
                  }
                });

                // Check for regions without units for this agency
                let userRoleRegions = [];
                if(allUserRoles && allUserRoles.length > 0){
                  userRoleRegions = allUserRoles.filter(r => r.Agency === agencyName).map(x => x[FieldNames.userRoles.region]);
                }
                agencyRegions.forEach(regionItem => {
                  if(userRoleRegions && !userRoleRegions.includes(regionItem)){
                    const regionItemToSave = unitsWithRegions.filter(x => x[FieldNames.units.region] === regionItem);
                    if(regionItemToSave && regionItemToSave.length > 0){
                      const userRole = {
                        [FieldNames.userRoles.appRole]: roleCode,
                        UserID: newUserID,
                        [FieldNames.userRoles.usersJoinID]: idVal,
                        Department: regionItemToSave[0][FieldNames.units.department],
                        Agency: regionItemToSave[0][FieldNames.units.agency],
                        Region: regionItem,
                        Unit: "",
                        SubUnit: "",
                        UnitType: "",
                        Tribe: ""
                      };
                      allUserRoles.push(userRole);
                    }
                  }
                });
            }
          }
        };

      // Process all agencies
      for(const agency of agencyItems) {
        await processAgency(agency);
      }
      return allUserRoles;
    }
}

export function getSuccessfulNewRoles(results, allUserRoles){
  let roleCount = 0;
  let allSuccessfulNewRoles = [];
  results.forEach(val => {
    if(val.success){
      allUserRoles[roleCount][FieldNames.userRoles.objectID] = val.objectId;
      allSuccessfulNewRoles.push(allUserRoles[roleCount]);
    }
  });
  return allSuccessfulNewRoles;
}

export function validateCacheByProfile(userInfo) {
  const isUserFuels = userInfo[FieldNames.userFields.isPostFire] === FieldNames.yesNo.yes;
  const isUserPostfire = userInfo[FieldNames.userFields.isPostFire] === FieldNames.yesNo.yes;
  const isFuelsOnly = isUserFuels && !isUserPostfire;
  const isPostFireOnly = !isUserFuels && isUserPostfire;
  const isFuelsAndPostFire = isUserFuels && isUserPostfire;
  const filterState = getFilterState();
  const menuState = getMenuState();
  if(filterState.dataset === FieldNames.datasets.both && !isFuelsAndPostFire)
  {
    const adjustedDataset = isFuelsOnly ? FieldNames.datasets.fuels : FieldNames.datasets.postfire;
    updateStore(setDataset, adjustedDataset);
    if(isFuelsOnly && filterState.filterProjectValue?.length > 0)
    {
      updateStore(setFilterProjectValue, []);
      updateStore(setProjectDiscoveryDates, []);
      updateStore(setProjectIDs, []);
      updateStore(setProjectFireCodes, []);
    }
  }
  if(isFuelsOnly)
  {
    if(filterState.dataset === FieldNames.datasets.postfire)
    {
      updateStore(setDataset, FieldNames.datasets.fuels);
      updateStore(setFilterProjectValue, []);
      updateStore(setProjectDiscoveryDates, []);
      updateStore(setProjectIDs, []);
      updateStore(setProjectFireCodes, []);
    }
    // Note: The following is temporary until Fuels allows Projects
    if(menuState.viewingProjects)
    {
      updateStore(setViewingActions, true);
      updateStore(setViewingProjects, false);
    }
  }
  if(isPostFireOnly)
  {
    if(filterState.dataset === FieldNames.dataset.fuels)
    {
      updateStore(setDataset, FieldNames.datasets.postfire);
    }
  }
}